import PropTypes from 'prop-types'

import MarkdownReader from '@/components/MarkdownReader'
import { translate } from '@/utils/translations'

const TRANSLATION_KEY = 'return_policy.modal.rules'

const WileyCodes = ({ returnWithinDays, unusedCodesWithinDays }) => (
  <>
    <li>
      <MarkdownReader>
        {translate(
          `${TRANSLATION_KEY}.used_registration_code`,
          { days: returnWithinDays }
        )}
      </MarkdownReader>
    </li>
    <li>
      <MarkdownReader>
        {translate(
          `${TRANSLATION_KEY}.unused_registration_code`,
          { days: unusedCodesWithinDays }
        )}
      </MarkdownReader>
    </li>
    <li>
      <MarkdownReader>
        {translate(`${TRANSLATION_KEY}.wiley_termination_policy`)}
      </MarkdownReader>
    </li>
  </>
)

WileyCodes.propTypes = {
  returnWithinDays: PropTypes.number.isRequired,
  unusedCodesWithinDays: PropTypes.number.isRequired
}

export default WileyCodes
